"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressIcon = exports.AddressHelper = exports.AddressInput = exports.AddressLabel = exports.AddressContainer = exports.SuggestionItem = exports.AutocompleteContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("color"));

var _palette = require("../../../../styles/palette");

var _widths = require("../../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var AutocompleteContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-bottom: ", ";\n  border-right : ", ";\n  border-left  : ", ";\n  box-shadow   : 0 2px 4px ", ";\n  border-radius: 0 0 2px 2px;\n  position     : absolute;\n  width        : 100%;\n  top          : 100%;\n  z-index      : 99;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n"])), _palette.palette.darkWhite, _palette.palette.darkWhite, _palette.palette.darkWhite, (0, _color["default"])(_palette.palette.bobBlack).fade(0.8).toString(), _widths.widths.base, _widths.widths.base);

exports.AutocompleteContainer = AutocompleteContainer;

var SuggestionItem = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  padding         : ", "px;\n  background-color: ", ";\n  cursor          : pointer;\n  font-weight     : ", ";\n  font-size       : 14px;\n"])), _widths.widths.base, _palette.palette.white, _widths.font.regular);

exports.SuggestionItem = SuggestionItem;
var DEFAULT_MAX_WIDTH = "".concat(_widths.widths.base * 40, "px");

var getMaxWidth = function getMaxWidth(_ref) {
  var width = _ref.width;
  return width ? typeof width === 'string' ? width : "".concat(width, "px") : DEFAULT_MAX_WIDTH;
};

var AddressContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  position    : relative;\n  min-height  : ", "px;\n  margin-bottom: ", "px;\n  max-width    : ", ";\n"])), _widths.widths.base * 7, _widths.widths.base * 3, getMaxWidth);

exports.AddressContainer = AddressContainer;

var AddressLabel = _styledComponents["default"].label(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color         : ", ";\n  left          : ", "px;\n  top           : ", ";\n  position      : absolute;\n  line-height    : 22px;\n  transition    : all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  z-index       : 1;\n  pointer-events: none;\n  user-select   : none;\n  font-size     : ", "px;\n  font-weight   : ", ";\n  display: flex;\n"])), function (props) {
  return props.error ? _palette.palette.error : props.color;
}, function (_ref2) {
  var status = _ref2.status,
      iconRight = _ref2.iconRight;
  return status === 'default' && !iconRight ? _widths.widths.base * 4 : 0;
}, function (props) {
  return props.status === 'default' ? 'calc(100% - 25px)' : 0;
}, function (props) {
  return props.status === 'default' ? 16 : 12;
}, _widths.font.regular);

exports.AddressLabel = AddressLabel;

var AddressInput = _styledComponents["default"].input(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  position        : absolute;\n  background-color: transparent;\n  border          : none;\n  left            : 0;\n  bottom          : 0;\n  font-size       : 16px;\n  line-height     : 22px;\n  padding-bottom  : 7px;\n  width           : ", ";\n  padding-left    : ", "px;\n  border-radius   : 0;\n  transition      : border-bottom 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  font-weight     : ", ";\n  border-bottom   : solid 1px ", ";\n  &:focus {\n    outline: none;\n    border-radius: 0;\n  }\n"])), function (_ref3) {
  var status = _ref3.status,
      iconRight = _ref3.iconRight;
  return status === 'default' || iconRight ? '100%' : "calc(100% - ".concat(_widths.widths.base * 4, "px)");
}, function (_ref4) {
  var status = _ref4.status,
      iconRight = _ref4.iconRight;
  return status === 'default' || iconRight ? 0 : _widths.widths.base * 4;
}, _widths.font.regular, function (props) {
  return props.error ? _palette.palette.error : props.color;
});

exports.AddressInput = AddressInput;

var AddressHelper = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  position   : absolute;\n  left       : 0;\n  margin-top : ", ";\n  bottom     : -20px;\n  z-index    : 1;\n  line-height: 16px;\n  color      : ", ";\n  font-size  : 12px;\n"])), _widths.widths.base, function (props) {
  return props.error ? _palette.palette.error : _palette.palette.grey;
});

exports.AddressHelper = AddressHelper;

var AddressIcon = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  ", ": 0;\n  top     : 28px;\n"])), function (_ref5) {
  var iconRight = _ref5.iconRight;
  return iconRight ? 'right' : 'left';
});

exports.AddressIcon = AddressIcon;
AutocompleteContainer.displayName = 'AutocompleteContainer';
SuggestionItem.displayName = 'SuggestionItem';
AddressContainer.displayName = 'AddressContainer';
AddressLabel.displayName = 'AddressLabel';
AddressIcon.displayName = 'AddressIcon';
AddressInput.displayName = 'AddressInput';
AddressHelper.displayName = 'AddressHelper';